<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template slot="item" slot-scope="props">
              <router-link
                :to="'/' + props.item.to"
                :disabled="props.item.disabled"
                v-bind:class="{
                  'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                    props.item.disabled,
                }"
                >{{ props.item.text }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{ responseError }}</span>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                readonly
                :rules="[() => !!queryParams.shopId || 'Shop is required.']"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :disabled="true"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.month"
                    label="Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.month"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-radio-group
                v-model="queryParams.balanceType"
                :mandatory="false"
                row
              >
                <v-radio label="All" value="ALL"></v-radio>
                <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1" style="overflow-x: auto; max-width: 100%;">
        <v-card row wrap style="width: fit-content;">
          <v-flex xs12 ml-2 pt-4>
            <div style="float: left; padding-left: 11px">
              <h3 style="margin: 0px; color: blue" id="counter">
                Manufacturing Account
              </h3>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float: left; padding-left: 11px">
              <p
                style="font-size: 13px; margin: 0px; font-weight: bold"
                id="counter"
              >
                Shop Code : {{ shopCode }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float: left; padding-left: 11px">
              <p
                style="font-size: 13px; margin: 0px; font-weight: bold"
                id="counter"
              >
                Date : {{ currentDate }}
              </p>
            </div>
          </v-flex>
          <br />
          <v-flex xs12 ml-2 pt-4>
            <v-layout row pt-4>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Code
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Name
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Nature</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget(%)
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount(%)</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget(%)
                  </h4>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 ml-2>
            <div style="width: 100%; height: 3px; background-color: blue"></div>
          </v-flex>
          <!-- Start ORIGINAL_COST -->
          <manufacturing-account-session
            :sessionName="'Original Cost'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'ORIGINAL_COST' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.originalCost"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.originalCostBudget"
            :showListLoading="showListLoading"
          />
          <!-- END ORIGINAL_COST -->

          <!-- Start PRODUCTION_COST -->
          <manufacturing-account-session
            :sessionName="'Production Cost'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'PRODUCTION_COST' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.productionCost"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.productionCostBudget"
            :showListLoading="showListLoading"
            :footer="'Total Production Cost'"
            :footerAmount="manufacturingAccount.totalProductionCost"
            :footerBudget="manufacturingAccount.totalProductionCostBudget"
            :useBgColor="true"
          />
          <!-- END PRODUCTION_COST -->

          <!-- Start PRODUCTION_VALUE -->
          <manufacturing-account-session
            :sessionName="'Production Value'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'PRODUCTION_VALUE' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.productionValue"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.productionValueBudget"
            :showListLoading="showListLoading"
            :footer="'Total Production Value'"
            :footerAmount="manufacturingAccount.totalProductionValue"
            :footerBudget="manufacturingAccount.totalProductionValueBudget"
            :useBgColor="true"
          />
          <!-- END PRODUCTION_VALUE -->

          <!-- Start VALUE_OF_GOODS_SOLD -->
          <manufacturing-account-session
            :sessionName="'Value Of Goods Sold'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'VALUE_OF_GOODS_SOLD' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.valueOfGoodsSold"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.valueOfGoodsSoldBudget"
            :showListLoading="showListLoading"
            :footer="'Value Of Goods Sold'"
            :footerAmount="manufacturingAccount.totalValueOfGoodsSold"
            :footerBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :useBgColor="true"
          />
          <!-- END VALUE_OF_GOODS_SOLD -->
        </v-card>
      </v-flex>

      <v-flex sm12>
        <div class="text-xs-center">
          <v-btn
            color="primary"
            :loading="saveLoading"
            @click="printInvoice('Print')"
          >
            Print
            <v-icon right>save</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <!-- Start Print -->
    <manufacturingAccountPrint
      id="Print"
      :maModel="manufacturingAccount"
      :fromMonth="queryParams.month"
      :toMonth="queryParams.month"
      :shopCode="shopCode"
      :shopName="shopName"
      :balanceType="queryParams.balanceType"
    ></manufacturingAccountPrint>
    <!-- End print  -->
  </v-container>
</template>
<script>
import { manufacturingAccountService } from "../../services/manufacturing-account-service";
import { shopService } from "../../services/shop-service";
import { ManufacturingAccount } from "../../models/model";
import { commonService } from "../../services/common-service";
import ManufacturingAccountPrint from "./ManufacturingAccountPrint.vue";
import manufacturingAccountSession from "./ManufacturingAccountSession.vue";
export default {
  name: "ManufacturingAccountDetail",
  components: { ManufacturingAccountPrint, manufacturingAccountSession },
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Mnaufacturing Account",
        disabled: true,
      },
      {
        text: "Manufacturing Account Detail",
        disabled: true,
      },
    ],
    queryParams: {
      shopId: "",
      month: new Date().toISOString().substr(0, 7),
      balanceType: "ALL",
    },
    currentDate: new Date().toISOString().slice(0, 10),
    responseError: "",
    saveLoading: false,
    shopCode: "",
    shopName: "",
    shopList: [],
    manufacturingAccount: new ManufacturingAccount(),
    oldManufacturingAccount: new ManufacturingAccount(),
    previewFilterObj: new ManufacturingAccount(),
    decimalFormat: "",
    menu: false,
    date: new Date(),
    headers: [
      { text: "Account Code", sortable: false, width: "1%" },
      { text: "Account Name", sortable: false, width: "1%" },
      { text: "Nature", sortable: false, width: "1%" },
      { text: "Amount", sortable: false, width: "1%", align: "right" },
      { text: "Amount(%)", sortable: false, width: "1%", align: "right" },
      { text: "", sortable: false, width: "1%" },
    ],
  }),

  created() {
    //for deep linking
    const id = this.$route.params.id;
    if (id == "new") {
      // new ManufacturingAccount
    } else {
      this.getIncomeStatementDetail(id);
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    getIncomeStatementDetail(id) {
      manufacturingAccountService
        .getManufacturingAccountById(id)
        .then((res) => {
          this.manufacturingAccount = res.data;
          this.shopCode = this.manufacturingAccount.shop.code;
          this.shopName = this.manufacturingAccount.shop.name;
          this.queryParams.shopId = this.manufacturingAccount.shopId;
          let date = new Date(
            this.manufacturingAccount.month +
              " 2 " +
              this.manufacturingAccount.year
          );
          this.queryParams.month = date.toISOString().substr(0, 7);
          this.oldManufacturingAccount = JSON.parse(JSON.stringify(res.data));
        });
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    goBack() {
      this.$router.push("/manufacturing-accounts");
    },

    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
  },
};
</script>
